// import easyflowImage from "../assets/img/products/easyflow-dashboard.png";
// import crmImage from "../assets/img/products/crm-dashboard.png";
// import aiImage from "../assets/img/products/ai-dashboard.png";

// import easyflowVideo from "../assets/videos/products/easyflow-demo.mp4";
// import crmVideo from "../assets/videos/products/crm-demo.mp4";
// import aiVideo from "../assets/videos/products/ai-demo.mp4";


// const ProductData = [

//   /* =========================================================
//      EASYFLOW
//   ========================================================= */

//   {
//     id: 1,

//     slug: "easyflow",

//     name: "EasyFlow",

//     tag: "BUSINESS MANAGEMENT",

//     tagline:
//       "Manage Projects. Empower Teams. Grow Your Business.",

//     description:
//       "A unified business management platform that helps organizations manage projects, tasks, teams, leads and quotations from one simple and connected workspace.",

//     image: easyflowImage,

//     video: easyflowVideo,

//     modules: [

//       {
//         name: "Projects",

//         description:
//           "Plan, organize and manage projects from start to completion with centralized project information and progress tracking.",
//       },

//       {
//         name: "Tasks",

//         description:
//           "Create, assign and track tasks while managing priorities, deadlines and progress across your projects.",
//       },

//       {
//         name: "Teams",

//         description:
//           "Bring teams together, manage responsibilities and improve collaboration with centralized team activities.",
//       },

//       {
//         name: "Leads",

//         description:
//           "Capture, organize and track potential customers throughout the sales journey to improve lead management.",
//       },

//       {
//         name: "Quotations",

//         description:
//           "Create, manage and track professional quotations while keeping customer and business information organized.",
//       },
      

//     ],
//   },


//   /* =========================================================
//      INDUSFLOW
//   ========================================================= */

//   {
//     id: 2,

//     /*
//       Keep "crm" if your existing route is:
//       /products/crm

//       If you want the URL to become:
//       /products/indusflow

//       change this to:
//       slug: "indusflow",
//     */

//     slug: "crm",

//     name: "IndusFlow",

//     tag: "MACHINE MONITORING",

//     tagline:
//       "Real-Time Insights for Smarter Manufacturing.",

//     description:
//       "A centralized manufacturing platform designed to monitor CNC machines, manage workforce operations, track inventory and provide real-time visibility into production performance.",

//     image: crmImage,

//     video: crmVideo,

//     modules: [

//       {
//         name: "Masters",

//         description:
//           "Centralize machines, operators, parts, processes and essential production data to keep manufacturing information organized and accessible.",
//       },

//       {
//         name: "Dashboard",

//         description:
//           "Get real-time visibility into machine status, production activity, downtime and overall manufacturing performance from one dashboard.",
//       },

//       {
//         name: "HRMS",

//         description:
//           "Manage employees, operators, attendance, shifts and workforce activities while keeping employee information organized.",
//       },

//       {
//         name: "Inventory",

//         description:
//           "Track raw materials, components, stock levels and material movement to maintain better control over manufacturing inventory.",
//       },

//       {
//         name: "Machine Monitoring",

//         description:
//           "Monitor CNC machines in real time and analyze runtime, downtime, utilization and production data for better operational decisions.",
//       },

//     ],
//   },


//   /* =========================================================
//      DOCPARSER AI
//   ========================================================= */

//   {
//     id: 3,

//     slug: "ai-solutions",

//     name: "Docparser AI",

//     tag: "AI SOLUTIONS",

//     tagline:
//       "Intelligence Built Into Your Workflow.",

//     description:
//       "An AI-powered document intelligence solution designed to simplify document processing, automate repetitive work, analyze information and help teams work faster.",

//     image: aiImage,

//     // video: aiVideo,

//     modules: [

//       {
//         name: "AI Assistant",

//         description:
//           "Use intelligent AI assistance to simplify everyday tasks, find information and support faster business decision-making.",
//       },

//       {
//         name: "Analysis",

//         description:
//           "Analyze documents and business information to identify important data, patterns and actionable insights.",
//       },

//       {
//         name: "Collaboration",

//         description:
//           "Enable teams to work together efficiently by sharing information, reviewing documents and coordinating business activities.",
//       },

//       {
//         name: "Documents",

//         description:
//           "Process and manage business documents efficiently while extracting important information and reducing manual effort.",
//       },

//       {
//         name: "Insights",

//         description:
//           "Turn processed information into meaningful insights that help teams understand data and make better decisions.",
//       },

//     ],
//   },

// ];


// export default ProductData;

import easyflowImage from "../assets/img/products/easyflow-dashboard.png";
import crmImage from "../assets/img/products/crm-dashboard.png";
import aiImage from "../assets/img/products/ai-dashboard.png";
import creditflowImage from "../assets/img/products/creditflow-dashboard.png";

import easyflowVideo from "../assets/videos/products/easyflow-demo.mp4";
import crmVideo from "../assets/videos/products/crm-demo.mp4";
import aiVideo from "../assets/videos/products/ai-demo.mp4";
import creditflowVideo from "../assets/videos/products/creditflow-demo.mp4";


const ProductData = [

  /* =========================================================
     1. INDUSFLOW
  ========================================================= */

  {
    id: 1,

    slug: "crm",

    name: "IndusFlow",

    tag: "MANUFACTURING & MACHINE MONITORING",

    tagline:
      "Real-Time Insights for Smarter Manufacturing.",

    description:
      "A centralized manufacturing platform designed to connect production operations, machine monitoring, workforce management and inventory into one intelligent workspace.",

    image: crmImage,

    video: crmVideo,

    modules: [

      {
        name: "Masters",

        description:
          "Centralize machines, operators, parts, processes and essential production data to keep manufacturing information organized and accessible.",
      },

      {
        name: "Dashboard",

        description:
          "Get real-time visibility into machine status, production activity, downtime and overall manufacturing performance from one connected dashboard.",
      },

      {
        name: "HRMS",

        description:
          "Manage employees, operators, attendance, shifts and workforce activities while keeping workforce information organized.",
      },

      {
        name: "Inventory",

        description:
          "Track raw materials, components, stock levels and material movement to maintain better control over manufacturing inventory.",
      },

      {
        name: "Machine Monitoring",

        description:
          "Monitor CNC machines in real time and analyze runtime, downtime, utilization and production data for better operational decisions.",
      },

    ],
  },


  /* =========================================================
     2. DOCPARSER AI
  ========================================================= */

  {
    id: 2,

    slug: "ai-solutions",

    name: "Docparser AI",

    tag: "AI & DOCUMENT AUTOMATION",

    tagline:
      "Turn Documents Into Intelligent Business Data.",

    description:
      "An AI-powered document intelligence solution that automates document processing, extracts valuable information and helps businesses reduce repetitive manual work.",

    image: aiImage,

    // video: aiVideo,

    modules: [

      {
        name: "AI Assistant",

        description:
          "Use intelligent AI assistance to interact with documents, find information and support faster business decision-making.",
      },

      {
        name: "Analysis",

        description:
          "Analyze documents and extracted business information to identify important data, patterns and actionable insights.",
      },

      {
        name: "Collaboration",

        description:
          "Enable teams to review, share and work together on processed documents and business information efficiently.",
      },

      {
        name: "Documents",

        description:
          "Process and organize business documents while extracting relevant information and reducing repetitive manual data entry.",
      },

      {
        name: "Insights",

        description:
          "Convert processed document data into meaningful insights that help teams understand information and make informed decisions.",
      },

    ],
  },


  /* =========================================================
     3. CREDITFLOW
  ========================================================= */

  {
    id: 3,

    slug: "creditflow",

    name: "CreditFlow",

    tag: "FINTECH & AI AUTOMATION",

    tagline:
      "Automate Lending. Accelerate Loan Decisions.",

    description:
      "An intelligent fintech loan automation platform designed to streamline the lending journey from application and document processing to verification, risk assessment and automated approval workflows.",

    image: creditflowImage,

    video: creditflowVideo,

    modules: [

      {
        name: "Loan Application",

        description:
          "Capture and manage borrower applications through a structured digital workflow, reducing manual processing and improving application efficiency.",
      },

      {
        name: "Document Processing",

        description:
          "Automate the collection, processing and verification of borrower documents to reduce paperwork and speed up the lending process.",
      },

      {
        name: "AI Verification",

        description:
          "Use AI-powered verification workflows to analyze applicant information and identify missing, inconsistent or important data.",
      },

      {
        name: "Credit Assessment",

        description:
          "Support faster lending decisions by evaluating relevant applicant information and organizing credit assessment data for review.",
      },

      {
        name: "Automated Approval",

        description:
          "Streamline loan decision workflows with configurable approval processes that help move eligible applications toward faster decisions.",
      },

    ],
  },


  /* =========================================================
     4. EASYFLOW
  ========================================================= */

  {
    id: 4,

    slug: "easyflow",

    name: "EasyFlow",

    tag: "BUSINESS MANAGEMENT",

    tagline:
      "Manage Projects. Empower Teams. Grow Your Business.",

    description:
      "A unified business management platform that helps organizations manage projects, tasks, teams, leads and quotations from one simple and connected workspace.",

    image: easyflowImage,

    video: easyflowVideo,

    modules: [

      {
        name: "Projects",

        description:
          "Plan, organize and manage projects from start to completion with centralized project information and progress tracking.",
      },

      {
        name: "Tasks",

        description:
          "Create, assign and track tasks while managing priorities, deadlines and progress across your projects.",
      },

      {
        name: "Teams",

        description:
          "Bring teams together, manage responsibilities and improve collaboration through centralized team activities.",
      },

      {
        name: "Leads",

        description:
          "Capture, organize and track potential customers throughout the sales journey to improve lead management.",
      },

      {
        name: "Quotations",

        description:
          "Create, manage and track professional quotations while keeping customer and business information organized.",
      },

    ],
  },

];


export default ProductData;